import {
  FaAddressBook,
  FaAnglesUp,
  FaAngleUp,
  FaArrowRightArrowLeft,
  FaBlackTie,
  FaBook,
  FaBullseye,
  FaCakeCandles,
  FaCalendarCheck,
  FaCalendarDay,
  FaCashRegister,
  FaChartBar,
  FaChartSimple,
  FaCircleLeft,
  FaCircleRight,
  FaCodePullRequest,
  FaCreditCard,
  FaDatabase,
  FaDisplay,
  FaDollarSign,
  FaFaceSmile,
  FaFreeCodeCamp,
  FaGears,
  FaGroupArrowsRotate,
  FaHouse,
  FaImages,
  FaLayerGroup,
  FaNewspaper,
  FaPercent,
  FaPlaneDeparture,
  FaReceipt,
  FaSackDollar,
  FaSquareCheck,
  FaTags,
  FaTicketSimple,
  FaUsers,
  FaUserTie,
  FaWarehouse,
  FaWaveSquare,
} from "react-icons/fa6";

const MenuAdmin = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Transaction",
    type: "menu-title",
  },
  {
    label: "Sales",
    to: "transaction/sales",
    icon: <FaReceipt />,
  },
  {
    label: "Sales Journal",
    to: "transaction/salesjournal",
    icon: <FaBook />,
  },
  {
    label: "Appointment",
    to: "transaction/appointment",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Follow up Appointment",
    to: "transaction/follow-up-appointment",
    icon: <FaCalendarDay />,
  },
  {
    label: "Customer Data",
    to: "transaction/customerdata",
    icon: <FaFaceSmile />,
  },
  {
    label: "Price List",
    to: "transaction/price-list",
    icon: <FaDollarSign />,
  },
  {
    label: "Birthday",
    to: "transaction/birthday",
    icon: <FaCakeCandles />,
  },
  {
    label: "Follow Up",
    to: "transaction/follow-up",
    icon: <FaSquareCheck />,
  },
  {
    label: "Vacation",
    to: "employee/vacation",
    icon: <FaPlaneDeparture />,
  },
  {
    label: "Attendance",
    to: "employee/attendance",
    icon: <FaAddressBook />,
  },
  {
    label: "Customer",
    type: "menu-title",
  },
  {
    label: "Request Expired Date",
    to: "customer/request-expired-date",
    icon: <FaAnglesUp />,
  },
  {
    label: "Package Request",
    to: "customer/package-request",
    icon: <FaCodePullRequest />,
  },
  {
    label: "Customer Voucher",
    to: "customer/vouchers",
    icon: <FaTicketSimple />,
  },
  {
    label: "Customer Discount",
    to: "customer/discounts",
    icon: <FaPercent />,
  },
  {
    label: "Stock",
    type: "menu-title",
  },
  {
    label: "Stock In",
    to: "stock/stockin",
    icon: <FaCircleLeft />,
  },
  {
    label: "Stock Out",
    to: "stock/stockout",
    icon: <FaCircleRight />,
  },
  {
    label: "Stock Transfer",
    to: "stock/stocktransfer",
    icon: <FaArrowRightArrowLeft />,
  },
  {
    label: "Stock Balance",
    to: "stock/stockbalance",
    icon: <FaChartSimple />,
  },
  {
    label: "Stock Movement",
    to: "stock/stockmovement",
    icon: <FaChartSimple />,
  },
  // {
  //   label: "Report",
  //   type: "menu-title",
  // },
  // {
  //   label: "Report",
  //   to: "report",
  //   icon: <FaChartBar />,
  // },
  {
    label: "Master & Setting",
    type: "menu-title",
  },
  // {
  //   label: "Master Transaksi",
  //   icon: <FaDatabase />,
  //   type: "menu-group",
  //   children: [
  //     {
  //       label: "Branch",
  //       to: "master/branch",
  //       icon: <FaBlackTie />,
  //     },
  //     {
  //       label: "Warehouse",
  //       to: "master/warehouse",
  //       icon: <FaWarehouse />,
  //     },
  //     {
  //       label: "Product Category",
  //       to: "master/productcategory",
  //       icon: <FaGroupArrowsRotate />,
  //     },
  //     {
  //       label: "Product Display",
  //       to: "master/productdisplay",
  //       icon: <FaDisplay />,
  //     },
  //     {
  //       label: "Product",
  //       to: "master/product",
  //       icon: <FaTags />,
  //     },
  //     {
  //       label: "Payment",
  //       to: "master/payment",
  //       icon: <FaCashRegister />,
  //     },
  //     {
  //       label: "Voucher",
  //       to: "master/voucher",
  //       icon: <FaCreditCard />,
  //     },
  //     {
  //       label: "Expense Group",
  //       to: "master/expensegroup",
  //       icon: <FaLayerGroup />,
  //     },
  //     {
  //       label: "Expense",
  //       to: "master/expense",
  //       icon: <FaSackDollar />,
  //     },
  //     {
  //       label: "Target",
  //       to: "master/target",
  //       icon: <FaBullseye />,
  //     },
  //     {
  //       label: "Discount",
  //       to: "master/discount",
  //       icon: <FaTags />,
  //     },
  //   ],
  // },
  {
    label: "Master CRM",
    icon: <FaWaveSquare />,
    type: "menu-group",
    children: [
      {
        label: "CRM Banner",
        to: "crm/crmbanner",
        icon: <FaImages />,
      },
      {
        label: "CRM News",
        to: "crm/crmnews",
        icon: <FaNewspaper />,
      },
      {
        label: "CRM Level",
        to: "crm/crmlevel",
        icon: <FaAngleUp />,
      },
      {
        label: "CRM Birthday Level",
        to: "crm/crmbirthdaylevel",
        icon: <FaAnglesUp />,
      },
      {
        label: "CRM Category",
        to: "crm/crmproductcategory",
        icon: <FaLayerGroup />,
      },
      {
        label: "CRM Product",
        to: "crm/crmproduct",
        icon: <FaTags />,
      },
    ],
  },
  // {
  //   label: "Master User",
  //   icon: <FaUsers />,
  //   type: "menu-group",
  //   children: [
  //     {
  //       label: "Customer",
  //       to: "master/customer",
  //       icon: <FaAddressBook />,
  //     },
  //     {
  //       label: "Employee",
  //       to: "master/employee",
  //       icon: <FaUserTie />,
  //     },
  //   ],
  // },
  // {
  //   label: "Setting",
  //   icon: <FaGears />,
  //   to: "setting/general",
  //   children: [],
  // },
];

export default MenuAdmin;
